import logoIcon from "../assets/logo-icon.png";

export function Footer() {
    return (
        <footer className="py-8 px-6 border-t border-slate-200 bg-white">
            <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-400">
                <div className="flex items-center gap-3">
                    <img src={logoIcon} alt="" className="h-6" />
                    <p>
                        © {new Date().getFullYear()} <span className="text-slate-600">appitep</span> — Tous droits réservés.
                    </p>
                </div>
                <div className="flex items-center gap-6">
                    <a href="https://appitep.fr" target="_blank" rel="noopener noreferrer" className="hover:text-[#f07020] transition-colors">
                        appitep.fr
                    </a>
                </div>
            </div>
        </footer>
    );
}
